import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonComponent } from '../button/button.component';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
    selector: 'app-delete-confirmation',
    standalone: true,
    imports: [
        CommonModule,
        InputTextModule,
        FormsModule,
        DialogComponent,
        ButtonComponent
    ],
    templateUrl: './delete-confirmation.component.html',
    styleUrls: ['./delete-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteConfirmationComponent implements OnChanges {

    @Input() visible: boolean = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    @Input() headerText: string = 'Confirm Delete';
    @ContentChild('headerTemplate') headerContentTemplate?: TemplateRef<any>;

    @Input() bodyText: string = 'Are you sure you want to delete this item?';
    @ContentChild('bodyTemplate') bodyContentTemplate?: TemplateRef<any>;

    @ContentChild('zipDownloadTemplate') zipDownloadTemplate?: TemplateRef<any>;

    @Input() confirmButtonText: string = 'Delete';
    @ContentChild('footerTemplate') footerContentTemplate?: TemplateRef<any>;

    @Input() requireConfirmation: boolean = false;

    @Input() width: string = '28rem';
    @Input() dialogStyleClass: string = 'mobile-fullscreen-dialog';
    @Input() closable: boolean = true;
    @Input() draggable: boolean = false;
    @Input() modal: boolean = true;
    @Input() loading: boolean = false;
    @Input() confirmationText: string = 'delete';

    @Output() onConfirm = new EventEmitter<void>();
    @Output() onCancel = new EventEmitter<void>();

    confirmationInput: string = '';

    get isSaveDisabled(): boolean {
        if (this.requireConfirmation) {
            return this.confirmationInput.toLowerCase() !== this.confirmationText.toLowerCase() || this.loading;
        }
        return this.loading;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && !changes['visible'].currentValue) {
            this.loading = false;
        }
    }

    handleConfirm() {
        if (!this.isSaveDisabled) {
            this.loading = true;
            this.onConfirm.emit();
        }
    }

    handleCancel() {
        this.onCancel.emit();
        this.closeDialog();
    }

    handleHide() {
        this.closeDialog();
    }

    closeDialog() {
        this.visible = false;
        this.visibleChange.emit(false);
        this.resetState();
    }

    resetState() {
        this.confirmationInput = '';
    }
}

